import {useRef, useState} from 'react';
import copyToClipboard from '../library/copyToClipboard';
import {addGooglePing} from '../redux/event/eventActions';
import {getDomain} from '../layout/eventMenu/formButtton/FormButtton';
import getEventUrl from '../functions/getEventUrl';
import {LIVE_DOMAIN, TICK_DOMAIN} from '../config/config';

const useAdvertiseActions = ({domain, landingPageUrl, name, type}: {domain: string; landingPageUrl?: string; name: string; type: string;}) => {
    const timer = useRef<NodeJS.Timeout | undefined>(undefined);

    const [copyText, setCopyText] = useState(null);
  
    const getEventLink = () => {
        return getDomain(domain, landingPageUrl, name, type);
    };
  
    const getQrCodeUrl = (qrRef = '2t24') => {
        const currentDomain = type === 'hub' ? LIVE_DOMAIN : TICK_DOMAIN;
        const urlPath = getEventUrl(domain, landingPageUrl || name, type, currentDomain);
        return `${urlPath}?ref=${qrRef}`;
    };
  
    const handleCopyText = (newText, defaultText) => {
        setCopyText(newText);
        timer.current = setTimeout(() => {
            setCopyText(defaultText);
        }, 3000);
    };
  
    const handleCopyLink = (successText, defaultText) => {
        const link = getEventLink();
        return copyToClipboard(link).then(() => {
            handleCopyText(successText, defaultText);
        });
    };
  
    const handleGooglePing = (isIndexed, updateGoogleIndex) => {
        if(isIndexed) {
            addGooglePing();
        } else {
            updateGoogleIndex(1);
        }
    };

    return {
        copyText,
        setCopyText,
        handleCopyText,
        handleCopyLink,
        handleGooglePing,
        getEventLink,
        getQrCodeUrl
    };
};

export default useAdvertiseActions;